import {Directive, Input} from '@angular/core';
import {ColFileStructure, SelectItem} from '@tj/tj-dmp-lib-api';

@Directive()
// tslint:disable-next-line:directive-class-suffix
export abstract class AbstractFilterComponent {
    @Input() cols: Array<ColFileStructure>;
    @Input() defaultEmptyValue = true;
    itemsCol: SelectItem[] = [];
    itemCol: string = null;
    example: string = null;

    protected handlerLoadEachItem(item: SelectItem) {
        //
    }

    protected updateListCol() {
        if (this.cols) {
            this.itemsCol = [];
            if (this.defaultEmptyValue) {
                this.itemsCol.push({
                    value: null,
                    label: 'Sélectionnez la colonne'
                });
            }
            this.cols.forEach(col => {
                const item = {
                    value: col.code,
                    label: col.name
                };
                this.itemsCol.push(item);
                this.handlerLoadEachItem(item);
            });
            this.updateExampleData();
        }
    }

    updateExampleData(field?): ColFileStructure {
        let itemCol;
        if (field) {
            itemCol = field;
        } else if (this.itemCol) {
            itemCol = this.itemCol;
        }
        if (itemCol) {
            // tslint:disable-next-line:triple-equals
            const col = this.cols.find(c => c.code == itemCol);
            this.example = col.exampleValues.join(', ');
            return col;
        } else {
            this.example = null;
        }
        return null;
    }
}
